import { signal } from "@preact/signals-react"

export const openDetails = signal(false)
export const reportIDSelected = signal(null)
export const tableData = signal([])